class exports.Router

    controller: (path, inject = [], customname = null) =>
        name = @_makeQualifiedName(path, customname, 'Controllers')
        cls = App.loadClass(path)

        inject.push cls
        @module.controller(name, inject)


    service: (path, inject = [], customname = null) =>

        name = @_makeQualifiedName(path, customname, 'Services')

        cls = App.loadClass(path)

        inject.push =>
            return new (cls)(arguments...)

        @module.factory name, inject


    factory: =>
        # TODO: maybe this could also use fancy qualified names?
        @module.factory(arguments...)


    filter: =>
        @module.filter(arguments...)


    _makeQualifiedName: (path, customname, mid_prefix) =>
        name = path.split('/')
        name = customname ? mid_prefix + '.' + List.last(name)

        if not @prefix?
            console.log "WARNING: No prefix used when registering #{name}. This could lead to name clashes"
        else
            name = @prefix + '.' + name

        return name


    # stub
    register: =>
        undefined

    # stub
    registerRoutes: =>
        undefined
